// extracted by mini-css-extract-plugin
export default {"spinner":"MySpinner_spinner__dn3X6","spinnerInner":"MySpinner_spinnerInner__12oy-","spin":"MySpinner_spin__9vifu"};